<div [ngClass]="mainClass">
  <div class="modal-header">
    <a href="" *ngIf="showCloseButton" (click)="close(true, $event)">
      <svg-icon src="assets/images/svg/icons/main-nav/close.svg"></svg-icon>
    </a>
  </div>
  <div appModalScroll class="modal-body">
    <ng-content></ng-content>
  </div>
</div>
<div class="small-modal-background" (click)="clickedOutside()"></div>
